import { render, staticRenderFns } from "./dialog-viewer.vue?vue&type=template&id=38ebb8df&"
import script from "./dialog-viewer.vue?vue&type=script&lang=js&"
export * from "./dialog-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports